<refx-app-layout refx-text-direction [@.disabled]="animationsDisabled$ | async">
  <refx-app-header-cont *ngIf="!(appConfigService.isAppEmbedded$ | async)" appHeader></refx-app-header-cont>
  <ng-container mainContent>
    <refx-app-skeleton-pres *ngIf="!firstRouteActivated && displaySkeletalLoader"></refx-app-skeleton-pres>
    <router-outlet (activate)="onRouteActivated()"></router-outlet>
  </ng-container>
  <refx-app-footer *ngIf="!(appConfigService.isAppEmbedded$ | async)" appFooter></refx-app-footer>
  <refx-debug-link-pres debugContent></refx-debug-link-pres>
</refx-app-layout>
<refx-gif-spinner class="gif-spinner" [loading]="isPending$ | async" [loadingComplete$]="loadingComplete$"></refx-gif-spinner>
<refx-lazy-outlet [loadComponent]="displayDebugPanel" [isActive]="showDebugPanel"></refx-lazy-outlet>
